import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-landing",
  "use": "icon-landing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-landing\"><path fill=\"#ffffff\" d=\"M106.666667 810.666667h810.666666v85.333333h-810.666666v-85.333333m306.346666-244.48l185.6 49.493333 226.56 60.586667c34.133333 8.96 69.12-11.093333 78.506667-45.226667 8.96-33.706667-11.093333-69.12-45.226667-78.506667l-226.56-60.586666-117.76-385.28-82.346666-21.333334v353.28L219.733333 381.866667l-39.68-98.986667-61.866666-16.64v220.586667l68.266666 18.346666 226.56 61.013334z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol